/**
 * Formats a phone number, expects input event
 * @param {InputEvent} e 
 * @returns 
 */
export const formatPhoneNumFromInput = e => {
    var oldVal = e.target.value;

    var newVal = oldVal.replace(/\D/g, '');
    var valLen = newVal.length;
    if (valLen >= 1)
        newVal = '(' + newVal.substring(0);
    if (valLen >= 3)
        newVal = newVal.substring(0, 4) + ') ' + newVal.substring(4);
    if (valLen >= 6) {
        newVal = newVal.substring(0, 9) + '-' + newVal.substring(9);
    }

    if (e.keyCode != 8) {
        return newVal;
    } else { return e.target.value; }
}

/**
 * Gets date difference in days
 * @param {Date} dateOne 
 * @param {Date} dateTwo
 */
export const dateDiffInDays = (a, b) => {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

/**
 * Determins whether or not value is array
 * 
 * @param {*} value 
 * @returns 
 */
export const isArray = (value) => {
    return Array.isArray(value) || (typeof value === 'object' && value !== null && value.length !== undefined);
}

/**
 * Takes time in seconds and formats it like "5 minutes"
 * 
 * @param {*} seconds
 */

export const formatTime = (seconds) => {
    const units = [
        { label: 'day', seconds: 86400 },
        { label: 'hour', seconds: 3600 },
        { label: 'minute', seconds: 60 },
        { label: 'second', seconds: 1 },
    ];

    for (const unit of units) {
        const count = Math.floor(seconds / unit.seconds);
        if (count >= 1) {
            return `${count} ${unit.label}${count > 1 ? 's' : ''}`;
        }
    }

    return '0 seconds';
}